<template lang="html" functional>
  <svg width="31px" height="19px" viewBox="0 0 31 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g transform="translate(-49.000000, -3900.000000)" :fill="props.fill">
        <g transform="translate(42.000000, 3635.000000)">
            <g transform="translate(7.000000, 76.950003)">
                <g transform="translate(0.599985, 188.599999)">
                    <path d="M28.9800007,10.0800002 L1.26000003,10.0800002 C0.564121228,10.0800002 0,9.515879 0,8.8200002 C0,8.1241214 0.564121228,7.56000017 1.26000003,7.56000017 L28.9800007,7.56000017 C29.6758795,7.56000017 30.2400007,8.1241214 30.2400007,8.8200002 C30.2400007,9.515879 29.6758795,10.0800002 28.9800007,10.0800002 L28.9800007,10.0800002 Z M28.9800007,2.52000006 L1.26000003,2.52000006 C0.564121228,2.52000006 0,1.95587883 0,1.26000003 C0,0.564121228 0.564121228,0 1.26000003,0 L28.9800007,0 C29.6758795,0 30.2400007,0.564121228 30.2400007,1.26000003 C30.2400007,1.95587883 29.6758795,2.52000006 28.9800007,2.52000006 L28.9800007,2.52000006 Z M1.26000003,15.1200003 L28.9800007,15.1200003 C29.6758795,15.1200003 30.2400007,15.6841216 30.2400007,16.3800004 C30.2400007,17.0758792 29.6758795,17.6400004 28.9800007,17.6400004 L1.26000003,17.6400004 C0.564121228,17.6400004 0,17.0758792 0,16.3800004 C0,15.6841216 0.564121228,15.1200003 1.26000003,15.1200003 L1.26000003,15.1200003 Z">
                    </path>
                </g>
            </g>
        </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    fill: String
  }
}
</script>
